import { render, staticRenderFns } from "./ForwardSettings.vue?vue&type=template&id=44d7f5b9&scoped=true&"
import script from "./ForwardSettings.vue?vue&type=script&lang=js&"
export * from "./ForwardSettings.vue?vue&type=script&lang=js&"
import style0 from "./ForwardSettings.vue?vue&type=style&index=0&id=44d7f5b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d7f5b9",
  null
  
)

export default component.exports